

























































































import {Component, Vue} from 'vue-property-decorator'
import Checkbox from "@/components/formComponents/core/Checkbox.vue";
import TextInput from "@/components/formComponents/core/TextInput.vue";
import Radiobutton from "@/components/formComponents/core/Radiobutton.vue";
import Button from "@/components/global/Button.vue";
import {IAddressee, ISupport} from "@/contract/support.contract";
import {isEmpty} from "lodash";
import Axios from 'axios';
import { Constants } from '@/constants';
import MessageModal from "@/components/modals/MessageModal.vue";
import {IModalConfig} from "@/contract/modal.contract";
import {reflectionIsSupported} from "vue-class-component/lib/reflect";
import TextArea from "@/components/formComponents/core/TextArea.vue";

@Component({
  methods: {isEmpty},
  components: {
    TextArea,
    MessageModal,
    Button,
    Checkbox,
    TextInput,
    Radiobutton,
  }
})
export default class SupportPage extends Vue {

  public isValidEmail = false;

  public inProcess = false;

  public showSuccess = false;
  public showFail = false;

  public answer: ISupport = {
    name: '',
    email: '',
    subject: '',
    body: '',
    to: [],
  }
  public addressees: IAddressee[] = [
    {
      name: "BENOR",
      isChecked: false,
      label: "BENOR"
    },
    {
      name: "BUtgb",
      isChecked: false,
      label: "BUtgb"
    },
    {
      name: "COPRO",
      isChecked: false,
      label: "COPRO",
    },
    {
      name: "BCCA",
      isChecked: false,
      label: "BCCA",
    },
    {
      name: "PROCERTUS",
      isChecked: false,
      label: "PROCERTUS",
    },
    {
      name: "BUCP",
      isChecked: false,
      label: "BUCP",
    }
  ]

  public successModal: IModalConfig = {
    title: `${this.$t('support.modals.success.title')}`,
    body: `${this.$t('support.modals.success.body')}`,
    centered: false,
  }
  public failModal: IModalConfig = {
    title: `${this.$t('support.modals.fail.title')}`,
    body: `${this.$t('support.modals.fail.body')}`,
    centered: false,
  }

  checkValidEmail(email: string) {
    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    this.isValidEmail = emailRegex.test(email);
  }

  isCorrectForm() {
    return (this.answer.name.length > 0 && this.answer.email.length > 0
        && this.answer.body.length > 0 && this.isValidEmail)
  }


  updateSelection(index: number, value: boolean) {
    this.addressees[index].isChecked = value;
    this.answer.to = this.selectedAddressees().map(addressee => addressee.name);
  }

  selectedAddressees() {
    return this.addressees.filter(addressee => addressee.isChecked);
  }

  redirectHome() {
    this.showSuccess = false;
    this.$router.push('Home')
  }

  async onSubmit() {
    this.inProcess = true;
    if (this.answer.to.length === 0) {
      this.answer.to = ["BUCP"];
    }
    await Axios.post(`${Constants.SupportMailUrl}`, this.answer)
        .then(() => {
          this.showSuccess = true;
        })
        .catch(() => {
          this.showFail = true;
        });
    this.inProcess = false;
  }

}
